"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const ritualSteps = [{
  id: "01",
  title: "Entender",
  description: "Mapear la carga: procesos, stack, objetivos, dolores."
}, {
  id: "02",
  title: "Trazar",
  description: "Encontrar y anclar el fulcro: arquitectura y roadmap."
}, {
  id: "03",
  title: "Construir",
  description: "Aplicar la fuerza: implementación técnica con documentación."
}, {
  id: "04",
  title: "Operar",
  description: "Mantener el movimiento: monitoreo, soporte, ajustes."
}, {
  id: "05",
  title: "Evolucionar",
  description: "Recalibrar el punto cuando el negocio crece."
}];
export default function CincoFases() {
  return <section data-section-id="226223" id="metodología" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden relative">
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes slowFadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-slow-fade {
          animation: slowFadeIn 1s ease-out forwards;
        }
      `
    }} />
      <div className="max-w-7xl mx-auto relative z-10">
        <header className="text-center mb-16 md:mb-24">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-normal mb-6 text-foreground leading-tight">
            Cinco fases. Una palanca.
          </h2>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 lg:gap-12 mb-16">
          {ritualSteps.map((step, i) => <div key={step.id} data-index={i} className="flex flex-col gap-4 animate-slow-fade" style={{
          animationDelay: `${i * 100}ms`
        }}>
              <span className="font-mono text-primary text-sm tracking-widest font-normal">
                {step.id}
              </span>
              <h3 className="font-serif text-2xl font-normal text-foreground leading-tight">
                {step.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed font-sans">
                {step.description}
              </p>
            </div>)}
        </div>

        <div className="flex justify-center">
          <Button asChild variant="default" size="lg" className="rounded-sm px-8">
            <Link to="https://fulcro.mx/metodologia/">
              Ver metodología completa <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}